module.exports = __webpack_public_path__ + "img/9.8efe73b5.jpg";